import { useMemo } from "react"

import {
  selectBridgeHistory,
  selectHasLoadedBridgeData,
  selectIsConnected,
  selectLatestBridgeTransactions,
  useDappSelector,
} from "#/redux-state"

import OverviewBridgeTransactionItem from "./OverviewBridgeTransactionItem"
import OverviewSection from "./OverviewSection"

export default function OverviewLatestTransactions() {
  const isConnected = useDappSelector(selectIsConnected)
  const bridgeHistory = useDappSelector(selectBridgeHistory)
  const hasLoadedBridgeData = useDappSelector(selectHasLoadedBridgeData)

  const latestBridgeTransactions = useDappSelector(
    selectLatestBridgeTransactions,
  )

  const sortedBridgeHistory = useMemo(() => {
    if (!bridgeHistory.length && !latestBridgeTransactions.length) {
      return []
    }

    const uniqueTransactions = Array.from(
      new Map(
        [...bridgeHistory, ...latestBridgeTransactions].map((item) => [
          item.transactionHash,
          item,
        ]),
      ).values(),
    )

    return uniqueTransactions
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, 5)
  }, [bridgeHistory, latestBridgeTransactions])

  if (!isConnected || (!bridgeHistory.length && hasLoadedBridgeData))
    return null

  return (
    <OverviewSection
      header="Latest Transactions"
      isLoading={!hasLoadedBridgeData}
    >
      {sortedBridgeHistory.map(({ amount, token, transactionHash }) => (
        <OverviewBridgeTransactionItem
          key={transactionHash}
          amount={amount}
          token={token}
          transactionHash={transactionHash}
        />
      ))}
    </OverviewSection>
  )
}
